import React from 'react';

const BookingHistory = () => {
  return (
    <div style={{ padding: 32 }}>
      <h2>Booking History</h2>
      <p>Booking history details will go here.</p>
    </div>
  );
};

export default BookingHistory; 